import { render, staticRenderFns } from "./ImNotify.vue?vue&type=template&id=3d3804da&scoped=true"
import script from "./ImNotify.vue?vue&type=script&lang=js"
export * from "./ImNotify.vue?vue&type=script&lang=js"
import style0 from "./ImNotify.vue?vue&type=style&index=0&id=3d3804da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3804da",
  null
  
)

export default component.exports